import './ContactForm.scss';
import Component from './ContactForm.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
